export class Gestor {
    id: number;
    gestor: string;
    correoGestor: string;
  }